<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm8>
        <p class="text-truncate">{{ broadcast.name }}</p>
      </v-flex>
      <v-flex xs12 sm4 text-xs-right>
        <v-btn
          fab
          v-if="draft"
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('editBroadcast', broadcast)"
        >
          <i class="fas fa-pencil-alt"></i>
        </v-btn>
        <v-btn
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('copyBroadcast', broadcast, draft?'draft':'sent')"
        >
          <i class="fas fa-copy"></i>
        </v-btn>
        <v-btn
          v-if="draft"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('deleteBroadcast', broadcast.id, broadcast.name)"
        >
          <i class="fas fa-trash"></i>
        </v-btn>
        <v-btn
          v-else
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('viewBroadcast', index)"
        >
          <i class="fas fa-eye"></i>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4 class="grey--text text--lighten-1 caption">
        <div>
          {{ broadcast.createdtime | DateFormat('DD/MM/YYYY hh:mm A') }}
        </div>
        <div>{{ $t('Created by') + ' ' }} {{ adminName }}</div>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-left text-sm-right">
        <v-chip color="info" text-color="white" small disabled v-if="broadcast.isschedule">
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          {{ broadcast.scheduletime | dateFormat('DD/MM/YYYY hh:mm A') }}
        </v-chip>
        <v-chip color="grey" text-color="white" small disabled v-else-if="draft">{{
          $t('Draft')
        }}</v-chip>
        <template>
          <v-chip
            v-if="parseFloat(broadcast.no_reach) > 0"
            color="#A0E83D"
            text-color="white"
            small
            disabled
            >{{ $t('Reach') + ' ' + broadcast.no_reach + ' ' + $t('users') }}</v-chip
          >
          <v-chip
            v-if="parseFloat(broadcast.no_unreach) > 0"
            color="red"
            text-color="white"
            small
            disabled
            >{{ $t('Unreach') + ' ' + broadcast.no_unreach + ' ' + $t('users') }}</v-chip
          >
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  props: ['broadcast', 'index', 'draft'],
  data() {
    return {
      //   broadcast: this.value,
    }
  },
  mounted() {
    if (this.broadcast.createdby && /^\d+$/.test(this.broadcast.createdby))
      this.getFbName(this.broadcast.createdby)
  },
  computed: {
    ...mapGetters(['selectedBot']),
    adminName() {
      var vm = this
      if (vm.broadcast.createdby) {
        if (/^\d+$/.test(vm.broadcast.createdby)) {
          var result = vm.$store.state.facebook_users_name.find(
            el => el.id == vm.broadcast.createdby
          )
          if (result) return result.name
        } else {
          return vm.broadcast.createdby
        }
      } else return ''
    }
  },
  methods: {
    async getFbName(userid) {
      var vm = this
      var fbusersname = vm.$store.state.facebook_users_name
      if (!fbusersname.some(el => el.id == userid))
        var result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${
            vm.selectedBot.page_access_token
          }`
        )
      if (result) {
        vm.$store.state.facebook_users_name.push(result.data)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastItem.vue